import {fromJS, Map } from 'immutable';
import config from 'config';
import actions from 'redux/constants/admin/institutions';
import history from '../../../../history';
import {checkJsonResponse, logErrorConsole} from 'utils/actions';

export const institutionIsSubmitting = (data) => ({
  type: actions.INSTITUTION_IS_SUBMITTING,
  data
});

export const institutionCreateFailed = (data) => ({
  type: actions.INSTITUTION_CREATE_FAILED,
  data
})

export const changeInstitutionValue = (data, key) => ({
	type: actions.SET_INSTITUTION_ITEM_VALUE,
	key,
	data
});


export const institutionChangeItem = (data) => ({
	type: actions.SET_INSTITUTION_ITEM,
	data
});

export const attachFile = (data) => (dispatch) => {
  const file = data;
  dispatch({
    type: actions.ATTACH_FILE,
    data: file
  });
}; 



export const onCleanParent = () => (dispatch) => {
  dispatch({
    type: actions.SET_INSTITUTION_PARENT,
    data: new Map()
  })
}


export const institutionCleanStore = () => (dispatch) => {
  dispatch(institutionChangeItem(new Map({
    hierarchy_level: null,
    institution_type: null,
    address: '',
    geographic_position: '',
    koatuu_code: '',
    edrpou_code: '',
    short_title: '',
    full_title: '',
    description: ''
  }))); 
}



export const istitutionsByLevelExeptLastIsLoading = (data) => ({
  type: actions.INSTITUTIONS_BY_LEVEL_EXEPT_LAST_ARE_LOADING,
  data
});

export const loadInstitutionsByLevelExeptLast = (limit, offset, search) => (dispatch) => {
  dispatch(istitutionsByLevelExeptLastIsLoading(true));
  return fetch(`${config.apiHost}/institution/?hierarchy_level__lte=2&limit=${limit}&offset=${offset}&search=${search}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTIONS_BY_LEVEL_EXEPT_LAST,
      data
    });
    return data
  })
  .catch(logErrorConsole)
  .then((data)=> {
    dispatch(istitutionsByLevelExeptLastIsLoading(false))
    return data
  })
};



export const submitNewInstitution = (url, id='', parentId='', parentFromLocation) => (dispatch, getState) => {
  dispatch(institutionIsSubmitting(true));
  dispatch(institutionCreateFailed(false));


  const formData = new FormData();
  formData.append('address', getState().adminInstitution.get('institutionItem').get('address'));
  formData.append('geographic_position', getState().adminInstitution.get('institutionItem').get('geographic_position'));
  formData.append('koatuu_code', getState().adminInstitution.get('institutionItem').get('koatuu_code'));
  formData.append('edrpou_code', getState().adminInstitution.get('institutionItem').get('edrpou_code'));
  formData.append('short_title', getState().adminInstitution.get('institutionItem').get('short_title'));
  formData.append('full_title', getState().adminInstitution.get('institutionItem').get('full_title'));
  formData.append('description', getState().adminInstitution.get('institutionItem').get('description'));
  formData.append('institution_type', getState().adminInstitution.get('institutionItem').get('institution_type'));
  formData.append('parent', parentId);

  const photo = getState().adminInstitution.get('institutionItem').get('photo');


   
  let method = id ? 'put' : 'post';
  let path = id ? `${config.apiHost}/institution/${id}/` : `${config.apiHost}/institution/`;

  var options = null

  if (!photo){
    options = {
      method,
      headers: {
        "Authorization": "Token " + getState().auth.get('token'),
        "Content-type": 'application/json'
      },
      body: JSON.stringify({
        address: getState().adminInstitution.get('institutionItem').get('address'),
        geographic_position: getState().adminInstitution.get('institutionItem').get('geographic_position'),
        koatuu_code: getState().adminInstitution.get('institutionItem').get('koatuu_code'),
        edrpou_code: getState().adminInstitution.get('institutionItem').get('edrpou_code'),
        short_title: getState().adminInstitution.get('institutionItem').get('short_title'),
        full_title: getState().adminInstitution.get('institutionItem').get('full_title'),
        description: getState().adminInstitution.get('institutionItem').get('description'),
        institution_type: getState().adminInstitution.get('institutionItem').get('institution_type'),
        parent: parentId,
        photo: null
      })
    }
  } else if(typeof photo === 'string') {
    options = {
      method,
      headers: {
        "Authorization": "Token " + getState().auth.get('token'),
        "Content-type": 'application/json'
      },
      body: JSON.stringify({
        address: getState().adminInstitution.get('institutionItem').get('address'),
        geographic_position: getState().adminInstitution.get('institutionItem').get('geographic_position'),
        koatuu_code: getState().adminInstitution.get('institutionItem').get('koatuu_code'),
        edrpou_code: getState().adminInstitution.get('institutionItem').get('edrpou_code'),
        short_title: getState().adminInstitution.get('institutionItem').get('short_title'),
        full_title: getState().adminInstitution.get('institutionItem').get('full_title'),
        description: getState().adminInstitution.get('institutionItem').get('description'),
        institution_type: getState().adminInstitution.get('institutionItem').get('institution_type'),
        parent: parentId
      })
    }
  } else {
    formData.append('photo', photo)
    options = {
      method,
      headers: {
        "Authorization": "Token " + getState().auth.get('token'),
      },
      body: formData
    } 
  }


  fetch(path, options)
  .then(checkJsonResponse)
  .then((json) => {
    if (parentFromLocation !== ''){
      history.push(`${url}${parentId}`)
    } else {
      history.push(`${url}${json.id}`)
    }
  })
  .catch(e => {
    dispatch(institutionCreateFailed(true));
    console.log(e);
  })
  .then(() => { 
    dispatch(institutionIsSubmitting(false))
  })
};


export const loadParentByParentPropertyIsLoading = (data) => ({
  type: actions.PARENT_BY_PARENT_IS_LOADING,
  data
});

export const onLoadParentByParentProperty = (parent) => (dispatch) => {
  dispatch(loadParentByParentPropertyIsLoading(true));
  return fetch(`${config.apiHost}/institution/${parent}/`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.SET_INSTITUTION_PARENT,
      data
    })
    return data
  })
  .catch(logErrorConsole)
  .then((data) => {
    dispatch(loadParentByParentPropertyIsLoading(false));
    return data
  })
};



export const loadInstitutionDetailAfterSearch = (id) => (dispatch) => {
  fetch(`${config.apiHost}/institution_type/?parent=${id}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.SET_NEW_INSTITUTION_DETAIL,
      data
    })
  })
  .catch(logErrorConsole)
};



export const institutionsByLevelAreLoading = (data) => ({
  type: actions.INSTITUTIONS_BY_LEVEL_ARE_LOADING,
  data
});

export const adminInstitutionLoading = (data) => ({
  type: actions.INSTITUTION_BINDINGS_LOADING,
  data
});

export const adminInstitutionSubmitting = data => ({
  type: actions.ADMIN_INSTITUTION_SUBMITTING,
  data
})

export const personalInstitutionProcessFailed = data => ({
  type: actions.PERSONAL_INSTITUTION_PROCESS_FAILED,
  data
})

export const serviceInstitutionProcessFailed = data => ({
  type: actions.SERVICE_INSTITUTION_PROCESS_FAILED,
  data
})

export const cleanInstitutionServiceDetailStore = () => ({
  type: actions.SET_SERVICE_INSTITUTION_ITEM,
  data: new Map()
})

export const cleanInstitutionPersonalDetailStore = () => ({
  type: actions.SET_PERSONAL_INSTITUTION_ITEM,
  data: new Map()
})



export const searchTypes = (parent) => (dispatch) => {
  dispatch(institutionsByLevelAreLoading(true));
  fetch(`${config.apiHost}/institution_type/?parent=${parent}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_INSTITUTIONS_BY_LEVEL,
      data
    });
  })
  .catch(logErrorConsole)
  .then (()=> {
    dispatch(institutionsByLevelAreLoading(false))
  })
};


export const deleteInstitution = (id, parent='') => (dispatch, getState) => {
  const options = {
    method: "delete",
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };
  fetch(`${config.apiHost}/institution/${id}/`, options)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then(() => {
    history.push(`/admin/institutions/detail/${parent}`);
  })
  .catch(e => {
    console.log(e);
  })
};


export const loadInstitutionDetail = (id) => (dispatch) => {
  return fetch(`${config.apiHost}/institution/${id}/`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.SET_INSTITUTION_ITEM,
      data
    })
  })
  .catch(logErrorConsole)
};

export const addServiceToInstitution = (serviceData, institutionId, serviceId = null) => (dispatch, getState) => {
  dispatch(adminInstitutionSubmitting(true))
  dispatch(serviceInstitutionProcessFailed(false))
  let method = serviceId ? 'PUT' : 'POST';
  let path = serviceId ? `${config.apiHost}/institution_service/${serviceId}/` : `${config.apiHost}/institution_service/`;

  const options = {
    method,
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({ ...serviceData, institution: institutionId })
  }

  fetch(path, options)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.SET_SERVICE_INSTITUTION_ITEM,
        data
      })
      dispatch(adminInstitutionSubmitting(false))
      let route = serviceId
        ? `/admin/institutions/${institutionId}/service/${serviceId}`
        : `/admin/institutions/detail/${institutionId}/subordinate-services`;
      history.push(route)
    })
    .catch(e => {
      console.log(e)
      dispatch(serviceInstitutionProcessFailed(true))
    })
};

export const loadInstitutionServiceDetail = serviceInstitutionId => (dispatch, getState) => {
  dispatch(adminInstitutionLoading(true))
  const options = {
    method: 'GET',
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }

  fetch(`${config.apiHost}/institution_service/${serviceInstitutionId}/`, options)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.SET_SERVICE_INSTITUTION_ITEM,
        data
      })
      dispatch(adminInstitutionLoading(false))
    })
    .catch(e => console.log(e))
};

export const deleteInstitutionService = (institutionId, serviceInstitutionId) => (dispatch, getState) => {
  dispatch(adminInstitutionSubmitting(true))
  const options = {
    method: 'DELETE',
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }

  fetch(`${config.apiHost}/institution_service/${serviceInstitutionId}/`, options)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      dispatch(adminInstitutionSubmitting(false))
      history.push(`/admin/institutions/detail/${institutionId}/subordinate-services/`)
    })
    .catch(e => {
      dispatch(serviceInstitutionProcessFailed(true))
    })
};


export const addPersonalToInstitution = (personalData, institutionId, personalId = null) => (dispatch, getState) => {
  dispatch(adminInstitutionSubmitting(true))
  dispatch(personalInstitutionProcessFailed(false))
  let method = personalId ? 'PUT' : 'POST';
  let path = personalId ? `${config.apiHost}/staff/${personalId}/` : `${config.apiHost}/staff/`;

  const options = {
    method,
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({ ...personalData, institution: institutionId })
  }

  fetch(path, options)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.SET_PERSONAL_INSTITUTION_ITEM,
        data
      })
      dispatch(adminInstitutionSubmitting(false))

      // const personalIdToRedirect = personalId || json.id
      const route = personalId
        ? `/admin/institutions/${institutionId}/personal/${personalId}`
        : `/admin/institutions/detail/${institutionId}/subordinate-personal/`;
      history.push(route)
    })
    .catch(e => {
      dispatch(personalInstitutionProcessFailed(true))
    })
};

export const loadInstitutionPersonalDetail = (personalInstitutionId, institutionId) => (dispatch, getState) => {
  dispatch(adminInstitutionLoading(true))
  const options = {
    method: 'GET',
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }

  fetch(`${config.apiHost}/staff/${personalInstitutionId}/?institution=${institutionId}`, options)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.SET_PERSONAL_INSTITUTION_ITEM,
        data
      })
      dispatch(adminInstitutionLoading(false))
    })
    .catch(e => console.log(e))
};

export const deleteInstitutionPersonal = (personalInstitutionId, institutionId) => (dispatch, getState) => {
  dispatch(adminInstitutionSubmitting(true))
  const options = {
    method: 'DELETE',
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }

  fetch(`${config.apiHost}/staff/${personalInstitutionId}/?instituttion=${institutionId}`, options)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      dispatch(adminInstitutionSubmitting(false))
      history.push(`/admin/institutions/detail/${institutionId}/subordinate-personal/`)
    })
    .catch(e => console.log(e))
};



// WEBPACK FOOTER //
// ./src/redux/actions/admin/institution/index.js